exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vip-grade-container[data-v-9163dc7c] {\n  padding: 20px;\n}\n.search-card[data-v-9163dc7c] {\n  margin-bottom: 10px;\n}\n.pagination-container[data-v-9163dc7c] {\n  margin-top: 20px;\n  text-align: right;\n}\n.compact-search-form[data-v-9163dc7c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports
